import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=1773ddaa"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1773ddaa')) {
      api.createRecord('1773ddaa', component.options)
    } else {
      api.reload('1773ddaa', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=1773ddaa", function () {
      api.rerender('1773ddaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AvatarList/Item.vue"
export default component.exports